import DataTypeModel from '../../../../models/DataType'
import apiUrl from '../../../Url/ApiUrl'
import { post } from '../../../methods'
import getFullUrl from '../../../../helpers/functions/getFullUrl'

export const getMemsourceJobs = (parameters, cancelToken) =>
    post(apiUrl.jobs.memsourceJobsList, DataTypeModel(parameters), cancelToken)

export const getMemsourceJobListInCsvUrl = (parameters) =>
    getFullUrl(apiUrl.jobs.memsourceJobsListCsv, DataTypeModel(parameters))
